exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropbox{outline:2px dashed grey;background:#f7fafc;color:#696969;position:relative;cursor:pointer;border-radius:10px;transition:background-color 2.5s ease}.input-file{opacity:0;width:100%;height:200px;position:absolute;cursor:pointer}.dropbox:hover{background:#add8e6}.dropbox p{font-size:1.2em;text-align:center;padding:50px 0}", ""]);

// exports
